import { popularMakeModels, popularMakes } from '@/reference';

export const searchCTALabel = ({ domainKey, label = '' }) => {

    let buttonLabel = ' Near You';

    switch (domainKey) {
        case 'CONDITION':
            buttonLabel = `Shop ${label}`;
            break;
        case 'MAKE':
            buttonLabel = 'Search ' + label + ' Models';
            break;

        case 'STYLE':
            buttonLabel = `Search ${label}${buttonLabel}`;
            break;

        default:
            buttonLabel = 'Search Vehicles';
    }

    return buttonLabel;
};

export const getSingularLabel = (code, label = '') => {
    if (code === 'SUVCROSS') {
        return 'SUV and Crossover';
    } if (code === 'VANMV') {
        return 'Van and Minivan';
    }
    return label.slice(0, -1);
};

export const yearDropDownMask = (years = []) => {

    const anyYearOption = {
        label: 'Any Year',
        value: '',
    };
    const allYears = years.map((year, index) => ({
        label: `${year}`,
        value: `${year}`,
    }));

    return [
        anyYearOption,
        ...allYears,
    ];
};

export const makeDropDownMask = (makes = [], usePopularMakes = true) => {
    const makeDropdownOptions = [{
        label: 'Any Make',
        value: '',
    }];

    if (makes.length > 0) {
        const popularMakesData = [];
        const allMakes = [];
        makes.forEach((make) => {
            const { makeCode, makeDescription } = make;
            if (makeDescription !== 'Any Make') {
                // check if in Popular Make list
                if (usePopularMakes && makeCode && Object.prototype.hasOwnProperty.call(popularMakes, makeCode)) {
                    popularMakesData.push({
                        value: makeCode,
                        label: makeDescription,
                    });
                }
                allMakes.push({
                    label: makeDescription || '',
                    value: makeCode || '',
                });
            }
        });
        if (usePopularMakes) {
            makeDropdownOptions.push(
                {
                    optgroup: 'Popular Makes',
                    options: popularMakesData,
                },
            );
        }
        makeDropdownOptions.push(
            {
                optgroup: 'All Makes',
                options: allMakes,
            }
        );
    }
    return makeDropdownOptions;
};

export const modelDropDownMask = (makeCode, models = []) => {
    const modelDropdownOptions = [{
        label: 'Any Model',
        value: '',
    }];

    const popularModelsData = popularMakeModels[makeCode]?.models || null;

    if (models.length > 0) {
        const popularModels = [];
        const allModels = [];
        models.forEach((model) => {
            if (model.label !== 'Any Model') {
                // check if in Popular Models list
                if (popularModelsData) {
                    if (popularModelsData.some((popularModel) => popularModel.value === model.value)) {
                        popularModels.push(model);
                    }
                }
                allModels.push(model);
            }
        });

        modelDropdownOptions.push(
            {
                optgroup: 'Popular Models',
                options: popularModels,
            },
            {
                optgroup: 'All Models',
                options: allModels,
            }
        );
    }
    return modelDropdownOptions;
};

// Inventory should have owner object for correct analytics
// ELot listings does not have an owner object included given
// that all listings belongs to one owner. this util includes it.
export const getInventoryWithOwner = ({ listings = [], owner = {} }) => {
    let listingsWithOwner;

    if (owner && Object.keys(owner).length > 0) {
        listingsWithOwner = listings.map((inv) => ({ ...inv, owner }));

    } else {
        listingsWithOwner = listings.map((inv) => ({ ...inv, owner: { id: inv.ownerId } }));
    }

    return listingsWithOwner;
};

export default {
    searchCTALabel,
    getSingularLabel,
    makeDropDownMask,
    modelDropDownMask,
    yearDropDownMask,
    getInventoryWithOwner,
};
